import { useState } from "react";

export default function TickerBadge({ symbol, size=44, glowColor }) {
  const [err, setErr] = useState(false);
  const PALETTES = [
    { bg:"linear-gradient(145deg,#2A1F06,#3D2D08)", color:"#e8c875" },
    { bg:"linear-gradient(145deg,#061828,#0A2244)", color:"#63A0FF" },
    { bg:"linear-gradient(145deg,#051A06,#082812)", color:"#34D399" },
    { bg:"linear-gradient(145deg,#1A0804,#241006)", color:"#FF6B35" },
    { bg:"linear-gradient(145deg,#130A2A,#1C1040)", color:"#A78BFA" },
  ];
  const hash = (symbol||"").split("").reduce((a,c)=>a+c.charCodeAt(0),0);
  const p = PALETTES[hash % PALETTES.length];
  const r = Math.round(size * 0.26);
  return (
    <div style={{
      width:size, height:size, borderRadius:r, flexShrink:0,
      background: err ? p.bg : "#141414",
      border:`1px solid ${err ? p.color+"28" : "rgba(255,255,255,0.09)"}`,
      display:"flex", alignItems:"center", justifyContent:"center",
      overflow:"hidden",
      boxShadow: glowColor ? `0 0 14px ${glowColor}40, 0 0 4px ${glowColor}20` : "0 2px 8px rgba(0,0,0,0.5)",
      position:"relative",
    }}>
      {!err
        ? <img src={`https://financialmodelingprep.com/image-stock/${symbol}.png`} alt={symbol}
            loading="lazy"
            onError={()=>setErr(true)}
            style={{ width:"82%", height:"82%", objectFit:"contain" }}/>
        : <span style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:Math.round(size*0.33), fontWeight:900, color:p.color, letterSpacing:".02em" }}>
            {(symbol||"").slice(0,2)}
          </span>
      }
    </div>
  );
}
